import React from "react";
import { Container } from "react-bootstrap";

export default function Legal() {
  return (
    <Container className="py-5">
      <h2>Impressum</h2>
      <p>
        Fluybuy GmbH<br/>
        Musterstraße 1<br/>
        12345 Musterstadt<br/>
        Deutschland<br/>
        Geschäftsführer: Max Mustermann<br/>
        Handelsregister: HRB 123456
      </p>

      <h2>AGB</h2>
      <p>
        <strong>1. Geltungsbereich</strong><br/>
        Diese AGB gelten für die Nutzung der Fluybuy-Website…
      </p>
      {/* …weitere AGB-Punkte… */}
    </Container>
  );
}
